import { Card, CardHeader, IconButton, Stack, Tooltip } from "@mui/material"
import DashboardLayout from "../../layoutcontainers/DashboardLayout"
import MaterialBox from "../../components/MaterialBox"
import { useUserDetails } from "../../context/auth";
import { Add, Delete, Edit, PictureAsPdf, Visibility } from "@mui/icons-material";
import { useEffect, useState } from "react";
import MaterialButton from "../../components/MaterialButton";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import BASEURL from "../Utils/Baseurl";
import { deleteEmployeeOfferLetterQuery, getAllOfferLetterQuery } from "./components/Queries";

const OfferLetterList = () => {

    const navigate = useNavigate();
    const { AccessData } = useUserDetails();
    const [isLoading, setIsLoading] = useState(false);
    const [employeeOfferLetters, setEmployeeOfferLetters] = useState([]);

    useEffect(() => {
        getEmployeeOfferLetters();
    },[])

    const getEmployeeOfferLetters = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                BASEURL,
                {
                    query: getAllOfferLetterQuery,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const result =
                response.data?.data?.employeeOfferLetterByAll;

            if (result?.success) {
                setEmployeeOfferLetters(result?.data || []);
            } else {
                console.error(
                    "Failed to fetch offer letters:",
                    result?.message
                );

                Swal.fire({
                    position: "center",
                    icon: "error",
                    title:
                        result?.message ||
                        "Failed to fetch offer letters",
                    showConfirmButton: false,
                    timer: 2500,
                });

                return [];
            }
        } catch (error) {
            console.error(
                "Error fetching employee offer letters:",
                error
            );

            Swal.fire({
                position: "center",
                icon: "error",
                title:
                    error?.response?.data?.errors?.[0]?.message ||
                    error?.message ||
                    "Failed to fetch offer letters",
                showConfirmButton: false,
                timer: 2500,
            });

            return [];
        }finally{
            setIsLoading(false);
        }
    };

    const handleDeleteOffer = async (id, title) => {        
        
        const confirmResult = await Swal.fire({
            title: "Are you sure?",
            text: `Do you want to delete ${title || "this offer letter"}?`,
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "Cancel",
            confirmButtonText: "Yes, delete it!",
        });

        if (!confirmResult.isConfirmed) {
            return;
        }

        try {
            const response = await axios.post(
                BASEURL,
                {
                    query: deleteEmployeeOfferLetterQuery,
                    variables: {
                        id: id,
                    },
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            const result =
                response.data?.data?.deleteEmployeeOfferLetter;

            if (result?.success) {
                await Swal.fire({
                    position: "center",
                    icon: "success",
                    title: result?.message || "Deleted successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });

                // Refresh your list here
                getEmployeeOfferLetters();
            } else {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: result?.message || "Failed to delete offer letter",
                    showConfirmButton: false,
                    timer: 2500,
                });
            }
        } catch (error) {
            console.error("Error deleting offer letter:", error);

            Swal.fire({
                position: "center",
                icon: "error",
                title:
                    error?.response?.data?.errors?.[0]?.message ||
                    error?.message ||
                    "Failed to delete offer letter",
                showConfirmButton: false,
                timer: 2500,
            });
        }
    };

    const handleFormNavigate = () => {
        navigate("/offer-letter/offer-Letter-Form");
    };

    const offerListTablleData = {
            columns: [
                {
                    field: "sno",
                    headerName: "S.No.",
                    flex: 0.4,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    field: "fullName",
                    headerName: "Full Name",
                    flex: 1.4,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    field: "salaryStructure",
                    headerName: "Salary Structure",
                    flex: 1.2,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                 {
                    field: "doj",
                    headerName: "Date of Joining",
                    flex: 1,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    field: "createdOn",
                    headerName: "Created On",
                    flex: 0.6,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    headerName: "Action",
                    field: "action",
                    name: "Action",
                    flex: 0.6,
                    disableColumnMenu: true,
                    editable: false,
                },
            ],
            rows: (employeeOfferLetters || []).map((value, i) => ({
              id: value.id,
              sno: i + 1,
              fullName: value?.fullName,
              salaryStructure: value?.salaryStructure?.structureName,
              doj: value?.doj,
              createdOn: new Date(value?.createdAt).toLocaleDateString("en-CA"),
              action: (
                <MaterialBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) => item.module === "Reports" && item.component === "ViewReports" && item.can_access
                    ) && (
                      <Tooltip
                        title="View"
                        placement="top"
                        disableInteractive
                        onClick={() => navigate(`/offer-letter/offer-Letter-Form?mode=view&id=${value?.id}`)}
                      >
                        <IconButton size="small">
                          <Visibility />
                        </IconButton>
                      </Tooltip>
                  )}
                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) => item.module === "Reports" && item.component === "ViewReports" && item.can_access
                    ) && (
                      <Tooltip
                        onClick={() => navigate(`/offer-letter/offer-pdf?id=${value?.id}`)}
                        title="View PDF"
                        placement="top"
                        disableInteractive
                      >
                        <IconButton size="small">
                          <PictureAsPdf />
                        </IconButton>
                      </Tooltip>
                  )}   
                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) => item.module === "Reports" && item.component === "EditReports" && item.can_access
                    ) && (
                      <Tooltip
                        title="Edit"
                        placement="top"
                        disableInteractive
                        onClick={() => navigate(`/offer-letter/offer-Letter-Form?mode=edit&id=${value?.id}`)}
                      >
                        <IconButton size="small">
                          <Edit />
                        </IconButton>
                      </Tooltip>
                  )}
                  {AccessData &&
                    Array.isArray(AccessData) &&
                    AccessData.some(
                      (item) => item.module === "Reports" && item.component === "EditReports" && item.can_access
                    ) && (
                      <Tooltip
                        onClick={() => handleDeleteOffer(value?.id, value?.fullName)}
                        title="Delete"
                        placement="top"
                        disableInteractive
                      >
                        <IconButton size="small">
                          <Delete />
                        </IconButton>
                      </Tooltip>
                  )}                                     
                </MaterialBox>
              ),
          })),
        };
  return (
    <DashboardLayout>
        <Card>
            <CardHeader
                sx={{
                    p: 2,
                    pb: 1,
                }}
                title={
                    <Stack
                        direction="row"
                        alignItems="flex-start"
                        justifyContent="space-between"
                        sx={{ width: "100%" }}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                Offer Letter List
                            </MaterialTypography>

                            <MaterialTypography variant="caption" fontWeight="medium">
                                List of Offer Letters uploaded directly
                            </MaterialTypography>
                        </Stack>

                        {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                                (item) =>
                                    item.module === "Reports" &&
                                    item.component === "AddReports" &&
                                    item.can_access
                            ) && (
                                <MaterialBox sx={{ ml: "auto" }}>
                                    <MaterialButton
                                        variant="gradient"
                                        color="dark"
                                        size="small"
                                        startIcon={<Add />}
                                        onClick={handleFormNavigate}
                                    >
                                        Offer
                                    </MaterialButton>
                                </MaterialBox>
                            )}
                    </Stack>
                }
            />
            <MaterialDataGrid
                rows={offerListTablleData.rows}
                columns={offerListTablleData.columns}
                loading={isLoading}
                noSearch={false}
                localeText={{
                noRowsLabel: (
                    <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                    >
                    <MaterialTypography
                        variant="body2"
                        fontWeight="medium"
                        color="text"
                    >
                        {"No Offers Uploaded yet"}
                    </MaterialTypography>
                    </Stack>
                ),
                }}
            />
        </Card>
    </DashboardLayout>
  )
}

export default OfferLetterList